module.exports = "/packs/media/images/income_estimate-590dea74ec1e609848d205e5287a6b75.png";